import React from 'react';
import OrganizationsConfig from './OrganizationsConfig';
import IntegrationConnection from './IntegrationConnection';
import { SensorAuthorization } from 'types';
import useCopilotIntegration from './hooks/useCopilotIntegration';
import useCopilotImportStrategySetting from './hooks/useCopilotImportStrategySetting';
import useCopilotImportStrategyForm from './hooks/useCopilotImportStrategyForm';
import useSaveHandler from './hooks/useSaveHandler';
import { LBButton } from '@linearb/buzz';
import { SENSORS_MAP } from '@linearb/linjs-common';

const CopilotSetting: React.FC = () => {
  const integration: SensorAuthorization | undefined = useCopilotIntegration();
  const copilotImportStrategySetting = useCopilotImportStrategySetting({
    sensorAuthId: integration?.id
  });
  const formState = useCopilotImportStrategyForm({
    settingValue: copilotImportStrategySetting.value
  });
  const saveHandler = useSaveHandler({
    settingValue: copilotImportStrategySetting.value,
    onSaveSetting: copilotImportStrategySetting.onSave,
    formState
  });

  return (
    <div className='flex h-full flex-col'>
      <h1 className='text-xl font-semibold text-gray-900'>
        GitHub Copilot Integration
      </h1>

      <div className='flex flex-col gap-20'>
        <div className='flex items-start justify-between'>
          <IntegrationConnection
            integration={integration}
            sensorId={SENSORS_MAP.COPILOT}
          />
          <LBButton
            disabled={saveHandler.isSaveDisabled}
            onClick={saveHandler.onSave}
          >
            Save
          </LBButton>
        </div>

        <OrganizationsConfig
          integration={integration}
          disabled={!integration}
          selectionMethod={formState.selectionMethod}
          regexPattern={formState.regexPattern}
          selectedOrgs={formState.selectedOrgs}
          onSelectionMethodChange={formState.setSelectionMethod}
          onRegexPatternChange={formState.setRegexPattern}
          onSelectedOrganizationsChange={formState.setSelectedOrgs}
        />
      </div>
    </div>
  );
};

export default CopilotSetting;
